export const TREE_LABEL_HIDE_IN_TREE = "none";
